import React, { useState, useEffect } from "react";

const GetSelectMonths = ({ onSelect, value }) => {
  const months = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];
  return (
    <select onChange={(e) => onSelect(e.target.value)} value={value}>
      <option value="">Select Month</option>
      {months.map((m) => (
        <option key={m.value} value={m.value}>
          {m.label}
        </option>
      ))}
    </select>
  );
};

const GetSelectYears = ({ onSelect, value }) => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) =>
    (currentYear - 5 + i).toString()
  );
  return (
    <select onChange={(e) => onSelect(e.target.value)} value={value}>
      <option value="">Select Year</option>
      {years.map((y) => (
        <option key={y} value={y}>
          {y}
        </option>
      ))}
    </select>
  );
};

const GetSelectStatus = ({ onSelect, value }) => {
  const statuses = [
    { value: "N", label: "Not Apply" },
    { value: "Y", label: "Apply" },
    { value: "F", label: "Failed" },
  ];
  return (
    <select onChange={(e) => onSelect(e.target.value)} value={value}>
      <option value="">Select Status</option>
      {statuses.map((s) => (
        <option key={s.value} value={s.value}>
          {s.label}
        </option>
      ))}
    </select>
  );
};

const StatusMonthYearSelector = ({ onSubmit, heading }) => {
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [status, setStatus] = useState("N");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const currentDate = new Date();
    setMonth((currentDate.getMonth() + 1).toString().padStart(2, "0"));
    setYear(currentDate.getFullYear().toString());
  }, []);

  const handleMonthChange = (selectedMonth) => {
    setMonth(selectedMonth);
    setErrorMessage("");
  };

  const handleYearChange = (selectedYear) => {
    setYear(selectedYear);
    setErrorMessage("");
  };

  const handleStatusChange = (selectedStatus) => {
    setStatus(selectedStatus);
    setErrorMessage("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (month && year && status) {
      setErrorMessage("");
      setLoading(true);
      onSubmit(month, year, status);
      setLoading(false);
    } else {
      setErrorMessage("Please select Status, Month and Year.");
    }
  };

  return (
    <>
      <div className="wrapper row3">
        <div id="container">
          <div style={{ display: "flex", justifyContent: "center" }}>
            <table width="40%">
              <thead>
                <tr className="tableheader">
                  <th colSpan={10}>{heading || "Change Statement Report"}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Month</td>
                  <td>
                    <GetSelectMonths
                      onSelect={handleMonthChange}
                      value={month}
                    />
                  </td>
                  <td>Year</td>
                  <td>
                    <GetSelectYears onSelect={handleYearChange} value={year} />
                  </td>
                  <td>Status</td>
                  <td>
                    <GetSelectStatus
                      onSelect={handleStatusChange}
                      value={status}
                    />
                  </td>
                </tr>
                <tr>
                  <td colSpan={10} align="center">
                    <button
                      onClick={handleSubmit}
                      className="button button2"
                      disabled={loading}
                    >
                      {loading ? "Loading..." : "Search"}
                    </button>
                    <button onClick={() => {}} className="button button2">
                      Back
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <br />
          {errorMessage && (
            <div
              style={{ textAlign: "center", color: "red", marginTop: "10px" }}
            >
              {errorMessage}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default StatusMonthYearSelector;
